
import axios from "axios";

export const LoginUser = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/login`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}

export const ForgotPassword = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/forgot-password`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}

export const ResetPassword = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/reset-password`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}